<template>
  <form id="frm_action">
    <div v-if="mode === 'add'" class="p-formgrid community-board-create-form">
      <div class="col-12">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="createForm.posting_on_behalf" :binary="true" @change="onChangePostingOnBehalf" />
            <label class="p-col-fixed txt-left text">Posting on behalf of others</label>
          </div>
        </div>
      </div>

      <div v-if="createForm.posting_on_behalf" class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-left txt-required">Owner</label>
          <div class="p-col">
            <Dropdown
              ref="ownerDropdown"
              v-model="createForm.owner_id"
              :options="ownerOptions"
              optionLabel="fullname"
              optionValue="id"
              placeholder="Choose"
              class="community-board-dropdown"
              appendTo="self"
              :filter="true"
              filterBy="fullname,email"
              @change="onChangeOwner"
            />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-left">Property</label>
          <div class="p-col">
            <Dropdown
              ref="propertyDropdown"
              v-model="createForm.property_id"
              :options="propertyOptions"
              optionLabel="display_name"
              optionValue="id"
              placeholder="Choose"
              class="community-board-dropdown"
              appendTo="self"
              :filter="true"
              filterBy="display_name"
              :disabled="createForm.posting_on_behalf === true && $commonFuction.isEmpty(createForm.owner_id)"
              @change="onChangeProperty"
            />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-left txt-required">Description</label>
          <div class="p-col">
            <div class="community-board-editor-wrap">
              <CkditorCore :contentSet="createForm.description" @newdata="handleCreateDescription" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 create-active-wrap">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="createForm.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar div-button community-board-create-toolbar">
        <template slot="right">
          <Button
            label="Cancel"
            @click.prevent="backToList"
            class="p-button-outlined community-board-cancel-button"
            id="back"
            :disabled="isSaving"
          />
          <Button
            label="Save"
            @click.prevent="saveData"
            class="main-style-button"
            :loading="isSaving"
            :disabled="isSaving"
          />
        </template>
      </Toolbar>
    </div>

    <div v-else class="p-formgrid community-board-form">
      <div class="row">
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-left">Full name</label>
            <div class="p-col">
              <InputText :value="post.fullname || ''" disabled />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-left">Property</label>
            <div class="p-col">
              <InputText :value="post.property_name || ''" disabled />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-left">Post detail</label>
          <div class="p-col">
            <div class="community-board-editor-wrap">
              <CkditorCore :contentSet="post.description || ''" @newdata="handleEditDescription" />
            </div>
          </div>
        </div>
      </div>

      

      <div class="col-12 reply-section">
        <div class="reply-title">Replies ({{ replyTree.length }}):</div>
        <div v-if="replyTree.length > 0" class="reply-list">
          <div class="reply-thread" v-for="item in replyTree" :key="item.id">
            <div class="reply-item">
              <div class="reply-left">
                <div class="reply-avatar-wrap">
                  <img v-if="item.avatar" :src="item.avatar" class="reply-avatar" />
                  <div v-else class="reply-avatar reply-avatar-empty"></div>
                </div>
                <div class="reply-content">
                  <div class="reply-head">
                    <div class="reply-name">{{ item.fullname || '-' }}</div>
                    <div class="reply-date">{{ formatDate(item.created_at) }}</div>
                  </div>
                  <div class="reply-property">[{{ item.property_name || 'Property name' }}]</div>
                  <ShadowHtml
                    class="reply-description"
                    :html="item.description || '-'"
                  />
                </div>
              </div>
              <button
                type="button"
                class="reply-delete"
                @click.prevent="deleteReply(item)"
              >
                <img src="/assets/images/icon/trash.svg" alt="Delete" class="reply-delete-icon" />
              </button>
            </div>
            <div v-if="item.children && item.children.length > 0" class="reply-children">
              <div class="reply-item reply-item-child" v-for="child in item.children" :key="child.id">
                <div class="reply-left">
                  <div class="reply-avatar-wrap">
                    <img v-if="child.avatar" :src="child.avatar" class="reply-avatar reply-avatar-child" />
                    <div v-else class="reply-avatar reply-avatar-empty reply-avatar-child"></div>
                  </div>
                  <div class="reply-content">
                    <div class="reply-head">
                      <div class="reply-name">{{ child.fullname || '-' }}</div>
                      <div class="reply-date">{{ formatDate(child.created_at) }}</div>
                    </div>
                    <div class="reply-property">[{{ child.property_name || 'Property name' }}]</div>
                    <ShadowHtml
                      class="reply-description"
                      :html="getReplyDescriptionHtml(child)"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  class="reply-delete"
                  @click.prevent="deleteReply(child)"
                >
                  <img src="/assets/images/icon/trash.svg" alt="Delete" class="reply-delete-icon" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="reply-empty">Empty data.</div>
      </div>
<div class="col-12 create-active-wrap ">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="post.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button
            label="Cancel"
            @click.prevent="backToList"
            class="p-button-outlined community-board-cancel-button"
            id="back"
            :disabled="isSaving"
          />
          <Button
            label="Save"
            @click.prevent="saveData"
            class="main-style-button"
            :loading="isSaving"
            :disabled="isSaving"
          />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import moment from "moment-timezone";
import ShadowHtml from "./ShadowHtml.vue";
import CkditorCore from "../CkditorCore.vue";

export default {
  components: {
    ShadowHtml,
    CkditorCore,
  },
  props: {
    mode: String,
    model: Object,
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.handleOutsideDropdownClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleOutsideDropdownClick);
  },
  data() {
    return {
      post: {},
      listReply: [],
      listDeleteReplyIds: [],
      createForm: {
        posting_on_behalf: false,
        property_id: null,
        owner_id: null,
        description: '',
        active: true,
      },
      adminUser: null,
      listProperty: [],
      time_zone_local: moment.tz.guess(true),
    }
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.mode === 'add') {
          this.initCreateData(val);
          return;
        }
        this.post = val?.post ? {...val.post} : {};
        this.listReply = val?.replies ? [...val.replies] : [];
        this.listDeleteReplyIds = [];
      }
    }
  },
  computed: {
    propertyOptions() {
      const listProperty = (this.listProperty ?? []).filter((item) => {
        if (this.createForm.posting_on_behalf !== true) {
          return true;
        }
        if (this.$commonFuction.isEmpty(this.createForm.owner_id)) {
          return false;
        }
        return (item.list_owner ?? []).some(owner => owner.id === this.createForm.owner_id);
      });
      return listProperty.map((item) => ({
        ...item,
        display_name: [item.code, item.name].filter(Boolean).join(' - '),
      }));
    },
    ownerOptions() {
      const mapOwner = {};
      (this.listProperty ?? []).forEach((item) => {
        (item.list_owner ?? []).forEach((owner) => {
          if (!this.$commonFuction.isEmpty(owner?.id) && !mapOwner[owner.id]) {
            mapOwner[owner.id] = owner;
          }
        });
      });
      return Object.values(mapOwner);
    },
    replyTree() {
      const listReply = Array.isArray(this.listReply) ? this.listReply : [];
      const mapReply = {};
      const rootReplies = [];

      listReply.forEach(item => {
        mapReply[item.id] = {
          ...item,
          children: [],
        };
      });

      listReply.forEach(item => {
        const currentReply = mapReply[item.id];
        if (item.parent_id && mapReply[item.parent_id]) {
          mapReply[item.parent_id].children.push(currentReply);
        } else {
          rootReplies.push(currentReply);
        }
      });

      return rootReplies;
    },
  },
  methods: {
    handleOutsideDropdownClick(event) {
      const listRef = ['ownerDropdown', 'propertyDropdown'];
      listRef.forEach((refName) => {
        const dropdown = this.$refs[refName];
        if (!dropdown || !dropdown.$el) {
          return;
        }
        if (dropdown.$el.contains(event.target)) {
          return;
        }
        if (typeof dropdown.hide === 'function') {
          dropdown.hide();
        }
      });
    },
    initCreateData(val) {
      this.adminUser = val?.user ?? null;
      this.listProperty = Array.isArray(val?.list_property) ? [...val.list_property] : [];
      this.createForm = {
        posting_on_behalf: false,
        property_id: val?.default_property?.id ?? null,
        owner_id: null,
        description: '',
        active: true,
      };
    },
    onChangePostingOnBehalf() {
      if (this.createForm.posting_on_behalf !== true) {
        this.createForm.owner_id = null;
        return;
      }
      this.createForm.property_id = null;
    },
    onChangeOwner() {
      if (this.createForm.posting_on_behalf !== true) {
        return;
      }
      if (!this.propertyOptions.find(item => item.id === this.createForm.property_id)) {
        this.createForm.property_id = null;
      }
    },
    onChangeProperty() {
      if (this.createForm.posting_on_behalf !== true) {
        return;
      }
    },
    handleCreateDescription(data) {
      this.createForm.description = Array.isArray(data) && data.length > 0 ? data[0] : '';
    },
    handleEditDescription(data) {
      this.post.description = Array.isArray(data) && data.length > 0 ? data[0] : '';
    },
    extractPlainText(html) {
      if (this.$commonFuction.isEmpty(html)) {
        return '';
      }
      const container = document.createElement('div');
      container.innerHTML = html;
      return (container.textContent || container.innerText || '').replace(/\s+/g, ' ').trim();
    },
    formatDate(value) {
      if (this.$commonFuction.isEmpty(value)) {
        return '';
      }
      return moment.tz(value, this.time_zone_local).format('MMM DD, YYYY [at] hh:mm A');
    },
    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getReplyDescriptionHtml(item) {
      const description = item?.description || '-';
      if (this.$commonFuction.isEmpty(item?.reply_to_fullname)) {
        return description;
      }
      return `<span style="color:#0051FF;font-weight:700;">@${this.escapeHtml(item.reply_to_fullname)}</span> ${description}`;
    },
    getReplyBranchIds(replyId) {
      const listIds = [];
      const queue = [replyId];
      while (queue.length > 0) {
        const currentId = queue.shift();
        if (this.$commonFuction.isEmpty(currentId) || listIds.includes(currentId)) {
          continue;
        }
        listIds.push(currentId);
        (this.listReply || []).forEach((item) => {
          if (item.parent_id === currentId) {
            queue.push(item.id);
          }
        });
      }
      return listIds;
    },
    deleteReply(item) {
      const deleteIds = this.getReplyBranchIds(item.id);
      this.listDeleteReplyIds = [...new Set([...this.listDeleteReplyIds, ...deleteIds])];
      this.listReply = this.listReply.filter(m => !deleteIds.includes(m.id));
    },
    saveData() {
      if (this.isSaving) {
        return;
      }
      if (this.mode === 'add') {
        if (this.createForm.posting_on_behalf === true && this.$commonFuction.isEmpty(this.createForm.owner_id)) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please choose owner', life: 3000 });
          return;
        }
        if (this.$commonFuction.isEmpty(this.extractPlainText(this.createForm.description))) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please input description', life: 3000 });
          return;
        }
        this.$emit('save', {
          property_id: this.createForm.property_id,
          uid: this.createForm.posting_on_behalf === true ? this.createForm.owner_id : null,
          posting_on_behalf: this.createForm.posting_on_behalf,
          description: this.createForm.description,
          active: this.createForm.active,
        });
        return;
      }
      this.$emit('save', {
        id: this.post.id,
        description: this.post.description,
        active: this.post.active,
        delete_reply_ids: [...new Set(this.listDeleteReplyIds)],
      })
    },
    backToList() {
      if (this.isSaving) {
        return;
      }
      this.$emit('back')
    },
  },
}
</script>

<style lang="scss">
.community-board-create-form {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > .col-12 {
    padding: 0 15px 8px;
  }

  .p-card-field {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .p-col {
    padding: 0;
  }

  .checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .p-col-fixed,
  label {
    font-family: 'Segoe UI', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #344054;
    margin-bottom: 2px;
    padding: 0px;
  }

  label.txt-required {
    color: #344054;
  }

  label.txt-required::after {
    color: #FF453A;
  }

  .community-board-dropdown {
    width: 100%;
  }

  :deep(.community-board-dropdown .p-dropdown) {
    width: 100%;
  }

  :deep(.community-board-dropdown .p-inputtext),
  :deep(.community-board-dropdown.p-dropdown) {
    background: #FFFFFF;
    border: 1px solid #D0D5DD;
    border-radius: 4px;
    min-height: 56px;
    display: flex;
    align-items: center;
  }

  .community-board-editor-wrap {
    border: 1px solid #D0D5DD;
    border-radius: 4px;
    overflow: hidden;
  }

  .create-active-wrap {
    border-top: 5px solid #F2F4F7;
    padding-top: 10px;
    margin-top: 4px;
  }

  .div_check .checkbox .text {
    margin-bottom: 0;
  }

  .community-board-create-toolbar.p-toolbar {
    background: #FFFFFF;
    border: 0;
    margin-top: 4px;
    padding: 0 24px;
    min-height: 60px;
  }

  .community-board-create-toolbar .p-toolbar-group-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: auto;
    margin-left: auto;
  }

  .community-board-create-toolbar .p-toolbar-group-right .p-button {
    min-width: 88px;
    width: auto;
    height: 36px;
    border-radius: 4px;
    margin: 0;
  }

  .community-board-cancel-button {
    border-color: #1D76BC;
    background: #FFFFFF;

    .p-button-label {
      color: #1D76BC !important;
      font-family: 'Segoe UI', sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.3125px;
    }
  }

  .main-style-button {
    min-width: 90px;
    height: 36px;
    background: #1D76BC;
    border-radius: 4px;
    margin-left: 0;
  }

  .main-style-button .p-button-label {
    font-family: 'Segoe UI', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.3125px;
    color: #FFFFFF;
  }
}

.community-board-form {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .row {
    align-items: flex-start;
    margin: 0;
    padding-left: 15px;
    padding-right: 15px;
  }

  > .col-12,
  > .reply-section,
  > .div-button {
    padding-left: 15px;
    padding-right: 15px;
  }

  .row > .col-6 {
    padding-left: 0;
    padding-right: 0;
  }

  .row > .col-6:first-child {
    padding-right: 15px;
  }

  .row > .col-6:last-child {
    padding-left: 15px;
  }

  .p-card-field {
    padding: 0 0 8px !important;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .p-col {
    padding: 0;
  }

  .p-inputtext[disabled] {
    background: #F2F4F7;
    color: #344054;
    border: 1px solid #D0D5DD;
    border-radius: 4px;
    opacity: 1;
  }

  .p-col-fixed,
  label {
    font-family: 'Segoe UI', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #344054;
    margin-bottom: 2px;
    padding: 0px;
  }

  .post-detail-box {
    background: #F2F4F7;
    border: 1px solid #D0D5DD;
    border-radius: 4px;
    padding: 16px 12px;
    min-height: 108px;
  }

  .post-title {
    font-size: 18px;
    font-weight: 700;
    color: #1F2A44;
    margin-bottom: 16px;
  }

  .post-description {
    color: #0F1724;
    line-height: 22px;
    font-size: 16px;
    font-weight: 700;
  }

  .reply-section {
    border-top: 5px solid #F2F4F7;
    padding-top: 12px;
    margin-top: 0;
  }

  .edit-active-wrap {
    border-top: 5px solid #F2F4F7;
    padding-top: 10px;
    margin-top: 0;
  }

  .div_check .checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .div_check .checkbox .text {
    margin-bottom: 0;
  }

  .reply-title {
    font-family: 'Segoe UI', sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    color: #344054;
  }

  .reply-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .reply-thread {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .reply-item {
    background: #F2F4F7;
    border: 1px solid #D0D5DD;
    border-radius: 10px;
    padding: 16px 12px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
  }

  .reply-children {
    margin-left: 0;
    padding-left: 50px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .reply-item-child {
    position: relative;
    padding: 16px 12px;
    border-radius: 8px;
  }

  .reply-item-child::before {
    content: '';
    position: absolute;
    left: -25px;
    top: -1px;
    bottom: -1px;
    width: 1px;
    background: #D9D9D9;
  }

  .reply-left {
    display: flex;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .reply-avatar-wrap {
    flex: 0 0 36px;
  }

  .reply-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    background: #E5EAF3;
  }

  .reply-avatar-child {
    width: 36px;
    height: 36px;
  }

  .reply-avatar-empty {
    border: 1px solid #D6DDE9;
  }

  .reply-content {
    flex: 1;
    min-width: 0;
  }

  .reply-head {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 4px;
  }

  .reply-name {
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    color: #111827;
  }

  .reply-date {
    color: #6B7280;
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
  }

  .reply-property {
    color: #6B7280;
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 16px;
  }

  .reply-description {
    color: #111827;
    line-height: 22px;
    font-size: 15px;
  }

  .reply-delete {
    margin-left: 0;
    align-self: flex-start;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  .reply-delete-icon {
    width: 24px;
    height: 24px;
    display: block;
  }

  .reply-empty {
    color: #7C889E;
  }

  .div-button .p-toolbar-group-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: auto;
    margin-left: auto;
  }

  .div-button.p-toolbar {
    background: #FFFFFF;
    border: 0;
    margin-top: 24px;
    padding: 0 24px;
    min-height: 84px;
    border-top: 1px solid #E5E7EB;
  }

  .div-button .p-toolbar-group-right .p-button {
    min-width: 88px;
    width: auto;
    height: 36px;
    border-radius: 4px;
    margin: 0;
  }

  .community-board-cancel-button {
    border-color: #1D76BC;
    background: #FFFFFF;

    .p-button-label {
      color: #1D76BC !important;
      font-family: 'Segoe UI', sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.3125px;
    }
  }

  .main-style-button {
    min-width: 90px;
    height: 36px;
    background: #1D76BC;
    border-radius: 4px;
    margin-left: 0;
  }

  .main-style-button .p-button-label {
    font-family: 'Segoe UI', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.3125px;
    color: #FFFFFF;
  }
}

</style>
